// extracted by mini-css-extract-plugin
export var deliveryRow = "_pt-a";
export var fixedHeight = "_pt-4";
export var freightLogo = "_pt-9";
export var fullWidth = "_pt-3";
export var priceColumn = "_pt-5";
export var radioSelected = "_pt-7";
export var radioUnselected = "_pt-6";
export var selectedOption = "_pt-2";
export var selectedOptionContainer = "_pt-1";
export var selection = "_pt-0";
export var tallSkeletonText = "_pt-8";